<div class="modal-header navbar-alertia">
    <h4 class="modal-title">Panic Alert</h4>
    <button type="button" class="close" (click)="activeModal.close()">&times;</button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12">
            {{'account.subscription_processed' | translate}}
        </div>
    </div>
</div>
<div class="modal-footer text-right">
    <button type="button" class="btn btn-blue btn-h-blue" (click)="activeModal.close()">
        Ok
    </button>
</div>
